const embedExternalScript = (url, callback) => {
  // Check if the script is already loaded
  if (document.querySelector(`script[src="${url}"]`)) {
    callback?.();
    return;
  }

  var script = document.createElement('script');
  script.src = url;
  script.async = true; // Ensure they don't block the main thread

  if (callback) {
    script.onload = () => callback(null);
    script.onerror = (err) => {
      console.warn(`Failed to load script: ${url}. This might be due to an ad-blocker or tracking protection.`);
      callback(err);
    };
  }

  var head = document.getElementsByTagName('head')[0];
  head.appendChild(script);
};
export default embedExternalScript;
